import { Controller } from "stimulus"

export default class extends Controller {
  visit(e) {
    e.currentTarget.classList.add("is-loading")
    Turbolinks.visit(e.currentTarget.dataset.path)
  }
}